/* leva-repr-sync.js
 * Pushes the module-family configurator's aggregated budget (total / material /
 * execution / time) to Firestore via LevaProjectStore.saveModule, so the MY LEVA
 * dashboard shows the same amounts as the product page. Polls the budget widget
 * (robust against the widget re-rendering its elements). No-op on base-family
 * pages (they write their own rich repr) and anywhere without a product handle.
 * Load on product pages, after leva-project-store and the budget widget.
 */
(function (global) {
  'use strict';

  if (global.BASE_BOOT) return;                        /* base family writes its own repr */

  function deriveHandle() {
    var b = global.SAUNA_BOOT;
    if (b && b.productHandle) return String(b.productHandle);
    try {
      var p = (global.location.pathname || '').split('/products/')[1] || '';
      return p.split('?')[0].split('#')[0].split('/')[0] || '';
    } catch (e) { return ''; }
  }
  var HANDLE = deriveHandle();
  if (!HANDLE) return;

  function num(id) {
    var el = global.document && document.getElementById(id);
    if (!el) return 0;
    var t = (el.textContent || '').replace(/[^0-9.,\-]/g, '').replace(/\s/g, '').replace(',', '.');
    var n = parseFloat(t);
    return isFinite(n) ? n : 0;
  }
  function compute() {
    var mat = num('cf-bw-material'), exec = num('cf-bw-execution'), tot = num('cf-bw-total'), hours = num('cf-bw-time');
    var m = (mat > 0) ? mat : (typeof global.lastMaterialsTotal === 'number' ? global.lastMaterialsTotal : 0);
    var e = (exec > 0) ? exec : (typeof global.lastDeliveryTotal === 'number' ? global.lastDeliveryTotal : 0);
    var tt = (tot > 0) ? tot : (m + e);
    return { materials: m, execution: e, total: tt, hours: hours || 0 };
  }

  var _last = '';
  function publish(t) {
    var store = global.LevaProjectStore;
    if (!store || typeof store.saveModule !== 'function') return;
    try {
      store.saveModule('repr_' + HANDLE, {
        budget: { materials: t.materials, execution: t.execution, total: t.total },
        hours: t.hours,
        updatedAt: new Date().toISOString()
      });
    } catch (e) {}
  }
  function tick() {
    var t = compute();
    if (!(t.total > 0)) return;                        /* widget not ready yet */
    var sig = t.materials + '|' + t.execution + '|' + t.total + '|' + t.hours;
    if (sig === _last) return;                          /* unchanged */
    _last = sig;
    publish(t);
  }
  function start() {
    setInterval(tick, 1500);
    global.addEventListener('pagehide', function () { var t = compute(); if (t.total > 0) publish(t); });
  }
  if (global.document && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}(window));